<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'visao' ? 'active' : ''" @click.prevent="abrir('visao')">
                        Visão Geral
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="( !aba || aba == 'lista' ) ? 'active' : ''" @click.prevent="abrir('lista')" >
                        Lista
                    </a>
                </li>
            </ul>
        </div>

        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load(false)" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            type="select" 
                            optionsMode="select"
                            optionsDisplay="search"
                            optionsData="id"
                            :optionsList="[
                                { id: 'P', search: 'Promotores' },
                                { id: 'N', search: 'Neutros' },
                                { id: 'D', search: 'Detratores' },
                            ]"
                            placeholder="Todos os Tipos..."
                            icon="fa fa-filter" 
                            v-model="filtro.id_status_nps" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa fa-filter" 
                            :edicao="dados ? true : false"
                            type="select" 
                            optionsMode="json"
                            :optionsList="dados ? dados.lista_status : []"
                            optionsData="id_contato_status"
                            placeholder="Todos o Status..."
                            v-model="filtro.id_contato_status" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="far fa-credit-card"
                            type="select" 
                            optionsMode="aql"
                            optionsData="id_operadora"
                            optionsDisplay="st_operadora"
                            service="operadoras.index"
                            :optionsParm="{ 
                                fatura: true,
                                classes: true,
                                lista: true
                            }"
                            optionsName="operadoras-para-fatura-2"
                            placeholder="Operadora..."
                            v-model="filtro.id_operadora">
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fas fa-file-contract"
                            type="autocomplete" 
                            optionsMode="aql"
                            optionsData="id_contrato_operadora"
                            optionsDisplay="search"
                            service="contrato_operadoras.index"
                            :optionsParm="{ id_operadora: filtro.id_operadora, guias: true }"
                            optionsName="contratos-busca-guia"
                            placeholder="Contrato..."
                            :edicao="filtro.id_operadora ? true : false"
                            v-model="filtro.id_contrato_operadora">
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fas fa-file-powerpoint"
                            type="autocomplete" 
                            optionsMode="aql"
                            optionsData="id_plano"
                            optionsDisplay="st_plano"
                            service="planos.index"
                            :optionsParm="{ id_operadora: filtro.id_operadora }"
                            :edicao="filtro.id_operadora ? true : false"
                            optionsName="planos"
                            placeholder="Plano..."
                            v-model="filtro.id_plano">
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input 
                            placeholder="Selecionar paciente..."
                            icon="fas fa-user"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            optionsData="id_pessoa"
                            ref="info_paciente"
                            v-model="filtro.id_paciente" 
                            :optimized_ac="true" />
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa-solid fa-user-doctor"
                            placeholder="Selecione o Profissional..."
                            type="select"
                            optionsMode="aql"
                            service="medicos.index"
                            optionsName="medicos-cadastro"
                            optionsData="id_pessoa"
                            :optionsParm="{ ativos: true }"
                            v-model="filtro.id_medico" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-4">
                        <az-input icon="fa fa-search fa-fw" v-model="search">
                            <template v-slot:buttonposb v-if="lista.length">
                                <print-export printid="impressao" :dados="dados_exportacao" :left="true" />
                            </template>
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            placeholder="Apoiado..."
                            icon="fa-solid fa-house-signal fa-fw"
                            type="autocomplete"
                            service="apoiados.index"
                            optionsMode="aql"
                            optionsName="apoiados.index"
                            optionsParm2="{ id_atendimento: dados.atendimento.id_atendimento }"
                            v-model="filtro.id_apoiado" />
                    </div>
                    
                    <div class="col col-12 col-md-3">
                        <div class="input-group mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa fa-building fa-fw" aria-hidden="true" :class="filtro.id_unidade_operacao ? 'text-success' : ''"></i>
                                </span>
                            </div>
                            <select class="form form-control" v-model="filtro.id_unidade_operacao">
                                <option value="">Unidades...</option>
                                <option v-for="(und, iux) in $util.unidades_com_tags(false, true)" 
                                    :value="und.id_unidade_operacao" :key="iux">{{ und.search }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fas fa-concierge-bell"
                            type="select"
                            placeholder="Todas as Recepções..."
                            :optionsList="lista_recepcoes"
                            optionsData="id_recepcao"
                            :edicao="filtro.id_unidade_operacao > 0"
                            v-model="filtro.id_recepcao" />
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>    

        <az-empty-state v-if="!lista || !lista.length" />

        <div id="impressao" v-else>

            <cabecalho-generico
                titulo="NPS">
                <div>
                    <div v-if="dados && dados.parametros && dados.parametros.unidade">
                        Unidade: {{ dados.parametros.unidade.st_nome }}
                    </div> 
                    <div v-if="dados && dados.parametros && dados.parametros.recepcao">
                        Recepção: {{ dados.parametros.recepcao.st_nome }}
                    </div> 
                    <div v-if="dados && dados.parametros && dados.parametros.id_status_nps">
                        Tipo: {{ dados.parametros.id_status_nps }}
                    </div> 
                    <div v-if="dados && dados.parametros">
                        Período: {{ $util.getFormatDate(dados.parametros.inicio) }} a {{ $util.getFormatDate(dados.parametros.fim) }}
                    </div>
                    <div v-if="search">
                        Filtro: {{ search }}
                    </div>      
                </div>
            </cabecalho-generico>

            <div class="row">
                <div class="col col-12 col-md-6">

                    <div class="alert alert-info d-flex justify-content-between" v-if="todos_atend">
                        <div>
                            Respostas: {{ promotores + neutros + detratores }} de {{ todos_atend }} atendimentos.
                        </div>
                        <div>
                            {{ $util.formatNumber( ( ( promotores + neutros + detratores ) / todos_atend ) * 100, 1 ) }}%
                        </div>
                    </div>

                </div>

                <div class="col col-12 col-md-6">

                    <div class="alert alert-info d-flex justify-content-between" v-if="promotores + neutros + detratores > 0">
                        <div>
                            Comentados: {{ comentados }} de {{ promotores + neutros + detratores }} respostas.
                        </div>
                        <div>
                            {{ $util.formatNumber( ( ( comentados ) / ( promotores + neutros + detratores ) ) * 100, 1 ) }}%
                        </div>
                    </div>

                </div>

            </div>

            <div class="card-deck mb-3">
                <div class="card">
                    <div class="card-body d-flex justify-content-between">
                        <div class="text-center">
                            <i class="fas fa-smile text-success fa-3x"></i>
                            <div class="small text-muted">Promotores</div>
                        </div>
                        <div class="display-4">
                            {{ promotores }}
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body d-flex justify-content-between">
                        <div class="text-center">
                            <i class="fas fa-meh text-warning fa-3x"></i>
                            <div class="small text-muted">Neutros</div>
                        </div>
                        <div class="display-4">
                            {{ neutros }}
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body d-flex justify-content-between">
                        <div class="text-center">
                            <i class="fas fa-frown text-danger fa-3x"></i>
                            <div class="small text-muted">Detratores</div>
                        </div>
                        <div class="display-4">
                            {{ detratores }}
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body d-flex justify-content-between">
                        <div class="text-center">
                            <i class="fas fa-star text-primary fa-3x"></i>
                            <div class="small text-muted">NPS</div>
                        </div>
                        <div class="display-4">
                            {{ nps }}
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="aba == 'visao'">

                <div class="mb-3">
                    <az-input   
                        type="button-group" 
                        :optionsList="[
                            { id: 'mes', search: 'Mês' }, 
                            { id: 'unidade', search: 'Unidade' }, 
                        ]"
                        v-model="tipo_quebra"
                        :edicao="!$store.state.loading"
                        @input="load()" />
                </div>

                <div class="card">
                    <table class="table mb-0">
                        <thead>
                            <tr>
                                <th>Descrição</th>
                                <th class="text-right">Promotores</th>
                                <th class="text-right">Neutros</th>
                                <th class="text-right">Detratores</th>
                                <th class="text-right">NPS</th>
                            </tr>
                        </thead>
                        <tr v-for="(item, iix) in lista_quebra" :key="iix">
                            <td>{{ item.quebra }}</td>
                            <td class="text-right">{{ item.p }}</td>
                            <td class="text-right">{{ item.n }}</td>
                            <td class="text-right">{{ item.d }}</td>
                            <td class="text-right">{{ item.nps }}</td>
                        </tr>
                    </table>
                </div>

                <div class="card">
                    <div class="card-header">Nuvem de Palavras</div>
                    <div class="card-body">
                        <wordcloud
                            :data="dados.palavras"
                            :showTooltip="false"
                            :wordClick="wordClickHandler"
                            nameKey="palavra"
                            valueKey="qtd" />
                    </div>
                </div>

            </template>

            <template v-else-if="dados && dados.parametros && !dados.parametros.visao">

                <table class="table bg-white">
                    <thead>
                        <tr>
                            <th width="5%" class="text-center">Score</th>
                            <th width="40%">Comentário</th>
                            <th width="10%">Data</th>
                            <th width="15%">Paciente</th>
                            <th width="15%">Contatos</th>
                            <th width="15%">Procedimento</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(marcacao, imx) in exibicao" :key="imx">
                            <td class="text-center">
                                <i class="fas fa-frown text-danger fa-2x" v-if="marcacao.in_nps_score < 7"></i>
                                <i class="fas fa-meh text-warning fa-2x" v-else-if="marcacao.in_nps_score < 9"></i>
                                <i class="fas fa-smile text-success fa-2x" v-else></i>
                                <div class="lead">
                                    {{ marcacao.in_nps_score }}
                                </div>
                            </td>
                            <td>
                                <small>
                                    <span v-if="marcacao.dt_nps">
                                        [{{ $util.getFormatDate(marcacao.dt_nps) }} {{ marcacao.dt_nps.substr(11,5) }}]:
                                    </span>
                                    {{ marcacao.st_nps_comentario }}
                                </small>
                            </td>
                            <td>
                                {{ $util.getFormatDate(marcacao.dt_inicio) }} 
                                <div class="small" v-if="marcacao.dt_inicio">
                                    {{ marcacao.dt_inicio.substr(11,5) }}
                                </div>
                            </td>
                            <td class="small">
                                {{ marcacao.paciente.st_nome }}
                                <div>
                                    <a class="card-link" href="#" @click.prevent="abrir_atendimento(marcacao)">
                                        #{{ marcacao.id_atendimento }}
                                    </a>
                                    <a href="#" @click.prevent="abrir_contatos(marcacao)" class="card-link">
                                        <i class="fas fa-comments"></i>
                                        <span class="badge badge-secondary ml-1" v-if="marcacao.contatos.length">
                                            {{ marcacao.contatos.length }}
                                        </span>
                                    </a>
                                    <span class="ml-2">
                                        <span v-if="marcacao.contatos.length">
                                            {{ marcacao.contatos[0].contato_status.search }}
                                        </span>
                                        <span v-else>
                                            Registrado
                                        </span>
                                    </span>
                                </div>
                            </td>
                            <td>
                                <celula-dados-contatos :hor="{ marcacao: marcacao }" />
                            </td>
                            <td class="small">
                                {{ marcacao.procedimento.search }}
                                <div class="text-muted">{{ marcacao.medico.st_nome_exibicao }}
                                    <span class="badge badge-light ml-1" v-if="marcacao.unidade_operacao && marcacao.unidade_operacao.st_sigla">
                                        {{ marcacao.unidade_operacao.st_sigla }}
                                    </span>
                                </div>
                            </td>                       
                        </tr>
                    </tbody>
                </table>

            </template>

            <!-- Paginação -->
            <nav class="navbar fixed-bottom navbar-light bg-light pb-3 d-print-none" v-if="dados && dados.lista.last_page > 1">
                <div class="d-flex">
                    <paginate
                        class="mb-0"
                        :page-count="dados.lista.last_page"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-link'"
                        :next-class="'page-link'"
                        :prev-text="'<<'"
                        :next-text="'>>'"
                        :click-handler="paginar">
                    </paginate>
                </div>
            </nav>

        </div>

        <registrar-contatos :lista_status="dados ? dados.lista_status : []" ref="regcontatos" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import CelulaDadosContatos from '../../shared/table/CelulaDadosContatos.vue';
import RegistrarContatos from '../../shared/RegistrarContatos.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import wordcloud from 'vue-wordcloud'

export default {
    data() { 
        return { 
            dados: null,
            from: this.$util.hoje(),
            to: this.$util.hoje(), 
            filtro: { 
                id_unidade_operacao: '', 
                id_recepcao: '', 
                id_status_nps: "", 
                periodo: "h",
                id_medico: "", 
                id_contato_status: "", 
                id_operadora: "",
                id_plano: "", 
                id_contrato_operadora: "", 
            }, 
            search: "", 
            canceltoken: null, 
            page: 1, 
            tipo_quebra: 'mes', 
        }
    },

    props: ['aba'], 

    components: { 
        AzInput,
        AzEmptyState, 
        CelulaDadosContatos,
        RegistrarContatos, 
        AzPeriodo, 
        PrintExport, 
        CabecalhoGenerico,
        wordcloud
    },

    computed: { 
        lista_quebra: function () { 
            return _.map(
                _.groupBy(
                    _.orderBy(this.dados.numeros, 'quebra'), 
                    'quebra'
                ), 
                (items, quebra) => { 
                    let ret = {
                        quebra: quebra, 
                        p: _.sumBy(items.filter(item => item.tipo == 'P'), 'qtde'),
                        n: _.sumBy(items.filter(item => item.tipo == 'N'), 'qtde'), 
                        d: _.sumBy(items.filter(item => item.tipo == 'D'), 'qtde'), 
                        o: _.sumBy(items.filter(item => item.tipo == 'O'), 'qtde'), 
                        nps: 0, 
                    };

                    let total = ( ret.p + ret.n + ret.d );

                    if ( total ) { 
                        ret.nps = Math.round( ( ( ret.p - ret.d ) / total ) * 100 );
                    }

                    return ret;

                }
            );
        },

        lista_recepcoes: function () { 
            if ( !this.filtro.id_unidade_operacao ) { 
                return [];
            }

            let unid = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.filtro.id_unidade_operacao);

            if ( unid ) { 
                return unid.recepcaos;
            } else { 
                return [];
            }
        },

        dados_exportacao: function () { 
            if ( this.dados && this.dados.parametros && this.dados.parametros.visao ) { 
                return [];
            }

            return this.lista.map(item => { 
                return { 
                    score: item.in_nps_score, 
                    nome_paciente: item.nome_paciente, 
                    id_atendimento: item.id_atendimento,
                    data_atendimento: this.$util.getFormatDate(item.dt_inicio), 
                    procedimento: item.procedimento.search,
                    medico: item.medico.st_nome_exibicao, 
                    unidade: item.unidade_operacao ? item.unidade_operacao.search : '', 
                    status: item.contatos.length
                        ? item.contatos[0].contato_status.search 
                        : 'Registrado',
                    data_resposta: this.$util.getFormatDate(item.dt_nps), 
                    comentario: item.st_nps_comentario, 
                    telefone: _.get(item, 'paciente.cadastro.telefones.telefone'), 
                    celular: _.get(item, 'paciente.cadastro.telefones.celular'), 
                };
            });
        },

        lista: function () { 
            if ( !this.dados || ( !this.dados.lista.data && !this.dados.parametros.visao ) )
                return []

            if ( this.dados.parametros.visao ) { 
                return this.dados.lista;
            }

            return this.dados.lista.data;
        },

        exibicao: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.lista.filter(item => ( !this.search || reg.test(JSON.stringify(item))));
        },

        todos_atend: function () { 
            return _.sumBy(this.dados.numeros, 'qtde');
        },

        comentados: function () { 
            return _.sumBy(this.dados.numeros, 'comentados');
        },

        promotores: function () { 
            return _.sumBy(this.dados.numeros.filter(item => item.tipo == 'P'), 'qtde');
        },

        neutros: function () { 
            return _.sumBy(this.dados.numeros.filter(item => item.tipo == 'N'), 'qtde');
        },

        detratores: function () { 
            return _.sumBy(this.dados.numeros.filter(item => item.tipo == 'D'), 'qtde');
        },

        nps: function () { 
            let total = this.promotores + this.neutros + this.detratores;

            if ( !total )
                return;

            return Math.round( ( ( this.promotores - this.detratores ) / total ) * 100 );
        }
    },

    methods: { 
        wordClickHandler(name) {
            if ( this.search == name ) { 
                this.search = "";     
            } else { 
                this.search = name;
            }

            //console.log('wordClickHandler', name, value, vm);
        },

        abrir(aba) { 
            if ( aba != this.aba ) { 
              this.$router.push({ path: '/nps/' + aba });
            }

            this.set_bread(aba);

            this.ja_buscou = false;

            if ( this.dados ) { 
                this.$nextTick(() => { 
                    this.load();
                });
            }
        },

        set_bread (aba = null) { 

            if ( !aba )
                aba = this.aba;

            if ( aba == 'visao' ) { 

                this.$store.commit("setBreadcrumb", [
                    { name: "NPS", path: "/nps" },
                    { name: "Visão Geral", path: "/nps/visao" },
                ]);

            } else { 

                this.$store.commit("setBreadcrumb", [
                    { name: "NPS", path: "/NPS" },
                    { name: "Lista", path: "/nps/lista" },
                ]);

            }

        },

        abrir_atendimento(item) { 
            this.$util.abrir_atendimento(this, item.id_atendimento);
        },
        
        paginar (page) {
            this.page = page;
            this.load(false);
        },

        abrir_contatos (marcacao) { 
            this.$refs.regcontatos.editar(marcacao);
        },

        load(pagina = null) { 
            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            if ( pagina ) { 
                this.page = pagina;
            }

            this.canceltoken = this.axios.CancelToken.source();

            this.$util.load(this, { 
                service: 'nps',
                func: 'index',
                canceltoken: this.canceltoken.token,
                parms: { 
                    from: this.from,
                    to: this.to, 
                    ...this.filtro,
                    page: this.page,
                    size: 200, 
                    visao: this.aba == 'visao',
                    quebra: this.tipo_quebra,  
                },
                page: this.page,
                reload_page: true, 
                loadTo: res => { 
                    this.dados = res;

                    if ( this.page && this.page > 1 && res.lista.last_page && this.page > res.lista.last_page ) { 
                        this.load(1);
                    }
                }
            });
        }
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "NPS", path: "/nps" }
        ]);

        this.load();
    }
}
</script>